import { Controller } from "@hotwired/stimulus"

// Small controller around a native <dialog> for confirmation.
// Handles:
//   - click->confirm-modal#open on the trigger (data-confirm-modal-target-param=<id>)
//   - click->confirm-modal#close on the cancel button
//   - keydown.esc->confirm-modal#close on the dialog itself
//   - backdrop click to close
// Focus-trap is provided by the native <dialog> element's showModal().
export default class extends Controller {
  open(event) {
    const targetId = event?.params?.target
    const dialog = targetId ? document.getElementById(targetId) : this.element
    if (!dialog) return
    if (typeof dialog.showModal === "function") {
      dialog.showModal()
    } else {
      dialog.setAttribute("open", "")
    }
  }

  close() {
    const dialog = this.element.closest("dialog") || this.element
    if (typeof dialog.close === "function") {
      dialog.close()
    } else {
      dialog.removeAttribute("open")
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.element) {
      this.close()
    }
  }
}
